import React from 'react';
import { ImageTitle } from '../../core/ImageTitle';
import { GenericComponent } from '../../dataForms/GenericComponent';

export class EcommercePouchTypeView extends React.Component {

    render() {
        return (
            <div className="view">
                <ImageTitle text='Pouch Types' />
                <GenericComponent dataObject='ecommerce-pouch-type' dataId={this.props.param_0} enableClone={false} />
            </div>
        );
    }
}